<template>
  <tr :class="isFlour ? 'table-info' : ''">
    <th scope="row">
      <b-form-input :value="ingredient.name" @change="onNameChange"></b-form-input>
    </th>
    <td>
      <b-input-group class="mx-auto">
        <b-form-input
          @change="onWeightChange"
          min="0"
          step="any"
          type="number"
          :value="displayWeight"
        />
        <template v-slot:append>
          <b-form-select
            class="input-group-text"
            v-model="weightType"
            :options="weightOptions"
          ></b-form-select>
        </template>
      </b-input-group>
    </td>
    <td>
      <b-input-group class="mx-auto" append="%">
        <b-form-input
          :disabled="isFlour || !isFinite(ingredient.ratio)"
          min="0"
          type="number"
          step="any"
          :value="displayRatio"
          @change="onRatioChange"
          placeholder="ADD FLOUR"
        />
      </b-input-group>
    </td>
    <td>
      <b-input-group append="%">
        <b-form-input
          :disabled="isFlour"
          min="0"
          type="number"
          step="any"
          :value="displayWaterLevel"
          @change="onWaterLevelChange"
        ></b-form-input>
      </b-input-group>
    </td>
    <td class="text-center">
      <b-button variant="outline-danger" @click="removeIngredient(ingredient)" pill>X</b-button>
    </td>
  </tr>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { WeightOptions } from '@/utils/constants'
import { checkFlour, getRatio, getWeight, convert } from '@/utils/helpers'

export default {
  name: 'IngredientRow',
  data() {
    return {
      weightOptions: [WeightOptions.GRAMS, WeightOptions.OUNCES],
      weightType: this.ingredient.weight.measurement,
      updateKey: { name: this.$vnode.key }
    }
  },
  props: {
    ingredient: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['flourWeightInGrams']),
    isFlour() {
      return checkFlour(this.ingredient.name)
    },
    displayWeight() {
      return +(+this.ingredient.weight.value).toFixed(2)
    },
    displayRatio() {
      return +(+this.ingredient.ratio).toFixed(2)
    },
    displayWaterLevel() {
      return +(+this.ingredient.hydration).toFixed(2)
    }
  },
  methods: {
    ...mapActions(['removeIngredient']),
    ...mapMutations(['updateIngredient']),
    onNameChange(newName) {
      this.updateIngredient({ key: this.updateKey, update: i => (i.name = newName) })
    },
    onWeightChange(newWeight) {
      if (this.isFlour) {
        this.$emit('flourChange')
        this.updateIngredient({ key: this.updateKey, update: i => (i.weight.value = newWeight) })
      } else {
        const newRatio =
          this.weightType === WeightOptions.GRAMS
            ? getRatio(newWeight, this.flourWeightInGrams)
            : getRatio(convert.ounces.toGrams(newWeight), this.flourWeightInGrams)
        const updateWeight = i => {
          i.weight.value = newWeight
          i.ratio = newRatio
        }
        this.updateIngredient({ key: this.updateKey, update: updateWeight })
      }
    },
    onRatioChange(newRatio) {
      if (this.isFlour) {
        console.log("Please don't change the flour!")
      } else {
        let newWeight = getWeight(newRatio, this.flourWeightInGrams)
        if (this.weightType === WeightOptions.OUNCES) {
          newWeight = convert.grams.toOunces(newWeight)
        }
        const updateRatio = i => {
          i.ratio = newRatio
          i.weight.value = newWeight
        }
        this.updateIngredient({ key: this.updateKey, update: updateRatio })
      }
    },
    onWaterLevelChange(newLevel) {
      this.updateIngredient({ key: this.updateKey, update: i => (i.hydration = newLevel) })
    }
  },
  watch: {
    weightType(newType, prevType) {
      let updateWeight = null
      if (newType === WeightOptions.OUNCES && prevType === WeightOptions.GRAMS) {
        updateWeight = i => {
          i.weight.value = convert.grams.toOunces(this.ingredient.weight.value)
          i.weight.measurement = WeightOptions.OUNCES
        }
      } else if (newType === WeightOptions.GRAMS && prevType === WeightOptions.OUNCES) {
        updateWeight = i => {
          i.weight.value = convert.ounces.toGrams(this.ingredient.weight.value)
          i.weight.measurement = WeightOptions.GRAMS
        }
      } else {
        console.log('Unable to Parse input')
      }
      this.updateIngredient({ key: this.updateKey, update: updateWeight })
    }
  }
}
</script>

<style src="./IngredientRow.scss" scoped lang="scss"></style>
